module.exports = __webpack_public_path__ + "media/images/payment_methods/paypal-bf79cb69db9ef5e9ce1aabe3bb7a8c1e.svg";